var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b',[(_vm.font)?_c('span',{class:'icon-' + _vm.font}):(_vm.src)?_c('img',{attrs:{"src":_vm.src,"alt":_vm.src}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }